import { AuthTypes } from './types';

export const loginRequest = (payload: any) => {
  return {
    type: AuthTypes.LOGIN_REQUEST,
    payload,
  };
};
export const loginSuccess = (payload: any) => {
  return {
    type: AuthTypes.LOGIN_SUCCESS,
    payload,
  };
};
export const loginFailure = (payload: any) => {
  return {
    type: AuthTypes.LOGIN_FAILURE,
    payload,
  };
};
